import { render, staticRenderFns } from "./SmsGetView.vue?vue&type=template&id=ca3fef8e&scoped=true&"
import script from "./SmsGetView.vue?vue&type=script&lang=js&"
export * from "./SmsGetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3fef8e",
  null
  
)

export default component.exports